<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Profile">
      <div class="text-center mt-0">
        <img
          class="text-center mt-0"
          :src="user.image"
          alt="../../assets/profile.png"
          width="50px"
        />
        <h3 class="mt-3">{{ user.name ? user.name : "-" }}</h3>
      </div>
    </base-block>
    <br />
    <base-block>
      <div>
        <b-tabs content-class="mt-3">
          <b-tab title="Details" active
            ><p>
              <base-block>
                <div class="bg-white rounded p-3 pr-3 pl-3 mb-3">
                  <div class="d-flex pro-det p-2">
                    <p class="mb-0 w-25">Mobile No</p>
                    <p class="mb-0 w-25 text-right">:</p>
                    <p class="mb-0 text-right w-50">
                      <b>{{ user.mobile ? user.mobile : "-" }}</b>
                    </p>
                  </div>
                  <div class="d-flex pro-det p-2">
                    <p class="mb-0 w-25">Email</p>
                    <p class="mb-0 w-25 text-right">:</p>
                    <p class="mb-0 text-right w-50">
                      <b>{{ user.email ? user.email : "-" }}</b>
                    </p>
                  </div>
                  <div class="d-flex pro-det p-2">
                    <p class="mb-0 w-25">Institution/College</p>
                    <p class="mb-0 w-25 text-right">:</p>
                    <p class="mb-0 text-right w-50">
                      <b>{{ user.college_name ? user.college_name : "-" }}</b>
                    </p>
                  </div>
                   <div class="d-flex pro-det p-2">
                    <p class="mb-0 w-25">Department</p>
                    <p class="mb-0 w-25 text-right">:</p>
                    <p class="mb-0 text-right w-50">
                      <b>{{ user.department ? user.department : "-" }}</b>
                    </p>
                  </div>
                  <div class="d-flex pro-det p-2">
                    <p class="mb-0 w-25">State</p>
                    <p class="mb-0 w-25 text-right">:</p>
                    <p class="mb-0 text-right w-50">
                      <b>{{ user.state ? user.state.name : "-" }}</b>
                    </p>
                  </div>
                 <!-- <div class="d-flex pro-det p-2">
                    <p class="mb-0 w-25">Reffered Number</p>
                    <p class="mb-0 w-25 text-right">:</p>
                    <p class="mb-0 text-right w-50">
                      <b>{{ user.referral_id ? user.referral_id : "-" }}</b>
                    </p>
                  </div>
                  <div class="d-flex pro-det p-2">
                    <p class="mb-0 w-25">Redeem Points Earned</p>
                    <p class="mb-0 w-25 text-right">:</p>
                    <p class="mb-0 text-right w-50">
                      <b>{{
                        user.redeem_points_earned
                          ? user.redeem_points_earned
                          : "-"
                      }}</b>
                    </p>
                  </div>
                  <div class="d-flex pro-det p-2">
                    <p class="mb-0 w-25">Redeem Points Spent</p>
                    <p class="mb-0 w-25 text-right">:</p>
                    <p class="mb-0 text-right w-50">
                      <b>{{
                        user.redeem_points_spent
                          ? user.redeem_points_spent
                          : "-"
                      }}</b>
                    </p>
                  </div>
                  <div class="d-flex pro-det p-2">
                    <p class="mb-0 w-25">Remaining Redeem Points</p>
                    <p class="mb-0 w-25 text-right">:</p>
                    <p class="mb-0 text-right w-50">
                      <b>{{
                        user.remaining_redeem_points
                          ? user.remaining_redeem_points
                          : "-"
                      }}</b>
                    </p>
                  </div>-->
                </div>
              </base-block>
            </p></b-tab
          >
          <b-tab
            title="Subscription"
            v-if="user.subscriptions ? user.subscriptions.length : false"
            ><p>
              <b-table-simple
                responsive
                bordered
                striped
                table-class="table-vcenter"
              >
                <b-thead>
                  <b-tr>
                    <b-th class="text-center" style="width: 50px">S.NO</b-th>
                    <b-th class="text-center">Package Name</b-th>
                    <b-th class="text-center">Start Date Time</b-th>
                    <b-th class="text-center">End Date Time</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr
                    v-for="(pack, index) in user.subscriptions"
                    :key="index"
                  >
                    <b-td class="text-center">
                      {{ index + 1 }}
                    </b-td>
                    <b-td class="text-center">{{
                      pack.sub ? pack.sub.name : "-"
                    }}</b-td>
                    <b-td class="text-center">{{ pack.start_date_time }}</b-td>
                    <b-td class="text-center">{{ pack.end_date_time }}</b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </p></b-tab
          >

          <b-tab title="Reports" v-if="tests.length > 0"
            ><p>
              <b-table-simple
                responsive
                bordered
                striped
                table-class="table-vcenter"
              >
                <b-thead>
                  <b-tr>
                    <b-th class="text-center" style="width: 50px">S.NO</b-th>
                    <b-th class="text-center">Test Name</b-th>
                    <b-th class="text-center">Test Type</b-th>
                    <b-th class="text-center">No Of Questions</b-th>
                    <b-th class="text-center">Negative Mark</b-th>
                    <b-th class="text-center">Each Question Mark</b-th>
                    <b-th class="text-center">Score</b-th>
                    <b-th class="text-center">Attended Date</b-th>
                    <b-th class="text-center">Action</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr v-for="(test, index) in tests" :key="index">
                    <b-td class="text-center">
                      {{ index + 1 }}
                    </b-td>
                    <b-td class="text-center">{{ test.name }}</b-td>
                    <b-td class="text-center">{{ test.test_type }}</b-td>
                    <b-td class="text-center">{{ test.no_of_questions }}</b-td>
                    <b-td class="text-center">{{ test.negative_mark }}</b-td>
                    <b-td class="text-center">{{
                      test.each_question_mark
                    }}</b-td>
                    <b-td class="text-center">{{ test.score }}</b-td>
                    <b-td class="text-center">{{ test.attended_date }}</b-td>
                    <b-td class="text-center">
                      <b-btn-group>
                        <router-link :to="{ name: 'College User Test Report', params: {collegeName: $route.params.collegeName, collegeId: $route.params.collegeId, userId: $route.params.userId, testId: test.id} }">
                          <b-button size="sm" variant="alt-primary">
                            <i class="fa fa-fw fa-eye"></i>
                          </b-button>
                        </router-link>
                      </b-btn-group>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple></p
          ></b-tab>
        </b-tabs>
      </div>
    </base-block>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      user: "",
      tests: "",
    };
  },
  mounted() {
    this.getCollegeUserDetails();
    this.getTests();
  },
  methods: {
    async getTests() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/tests-list/${this.$route.params.userId}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.collegeToken}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.tests = response.data.test_lists;
          } else {
            this.$swal("Success", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getCollegeUserDetails() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/college_users_detail/${this.$route.params.userId}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.collegeToken}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.user = response.data.user_detail;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>